var map = {
	"./banner.jpg": 92,
	"./cawee.png": 93,
	"./gdg_addis.png": 94,
	"./hacking.jpg": 95,
	"./hackv1/image1.jpg": 96,
	"./hackv1/image2.jpg": 97,
	"./logo.png": 98,
	"./my_pic.jpg": 99,
	"./prize.jpg": 100,
	"./teams.jpg": 101,
	"./us_embassy.png": 102,
	"./usaid.png": 103
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = 36
// module chunks = 1